const concatValues = values => values.filter(value => value !== "").join("|");
export default concatValues;
